export default "../images/fuindedfi-checkmark-ligh-gold.png?4b977cf2bfea829a982805aebe57b960";